import React, { useCallback, useState } from 'react';
import { Box, IconButton, useDisclosure, useTheme } from '@chakra-ui/react';
import { Button } from '../button/button';
import TerminatedAgreementModal from 'components/SearchResults/terminated-agreement-modal';
import useUser from 'data-client/use-current-user';
import { useUserTierChecks } from 'hooks/authorization-hooks';
import { useHistory } from 'react-router-dom';
import { useReferralCtaClickEventMutation } from 'data-client/member-events';
import { RiGiftLine } from 'react-icons/ri';
import ReferralModal from 'features/Referral/referral-modal';

export function NewReleaseButton() {
  const { isExecutiveTier } = useUserTierChecks();
  const [user] = useUser();
  const terminatedAgreementModal = useDisclosure();
  const history = useHistory();
  const [isReferralModalOpen, setIsReferralModalOpen] = useState(false);

  const theme = useTheme();

  const canSendReferrals = user?.subscription?.isBanned === false;
  const referralCtaClickEventMutation = useReferralCtaClickEventMutation();

  const handleCreateReleaseButton = () => {
    if (isExecutiveTier && !user?.serviceDeal) {
      terminatedAgreementModal.onOpen();
      return;
    }
    history.push('/manage');
  };

  const openReferralModal = useCallback(() => {
    referralCtaClickEventMutation.mutate();
    setIsReferralModalOpen(true);
  }, [referralCtaClickEventMutation, setIsReferralModalOpen]);

  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        {canSendReferrals && (
          <IconButton
            background="brown.500"
            borderColor="brown.700"
            _hover={{ background: 'brown.500' }}
            width="40px"
            height="40px"
            borderRadius="full"
            icon={<RiGiftLine color={theme.colors.black100} size={16} />}
            onClick={openReferralModal}
            aria-label="Earn $100 per referral"
          />
        )}
        <Button disabled={!user?.subscription?.isActive} onClick={handleCreateReleaseButton}>
          Release a New Song
        </Button>
      </Box>
      <TerminatedAgreementModal
        isOpen={terminatedAgreementModal.isOpen}
        onClose={terminatedAgreementModal.onClose}
        variant="short"
        cancelText="close"
      />
      <ReferralModal
        isOpen={isReferralModalOpen}
        noFooter
        onClose={() => setIsReferralModalOpen(false)}
        variant="light"
      />
    </>
  );
}
